























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import notificationService from '@/services/notificationService';
import cCard from '@/components/default/Card.vue';
import filesRepository from '@/services/varia/filesRepository';
import { DxTreeList, DxColumn, DxRemoteOperations, DxButton } from 'devextreme-vue/tree-list';
import cPopup from '@/components/default/Popup.vue';
import settings from '@/settings.json';
import { DxFileUploader } from 'devextreme-vue/file-uploader';

@Component({
  components: {
    cCard,
    DxTreeList,
    DxColumn,
    DxRemoteOperations,
    DxButton,
    DxFileUploader,
    cPopup,
  },
  computed: {

  },
})
export default class FilesTreeList extends Vue {
  @Prop({required: true})
  public type!: string;

  @Prop({required: true})
  public id!: string;

  public addPopupValue: boolean = false;

  private listItems: any[] = [];
  private showAddFilePopup: boolean = false;
  private accessToken: string = '';
  private selectedFolder: string = '';

  public add(folderId: string = '') {
    this.addPopupValue = false;
    this.showAddFilePopup = true;
    this.selectedFolder = '';
    if (!folderId || folderId === '') {
      this.selectedFolder = '';
    } else {
      let listItem = this.listItems.find((o: any) => o.key === folderId);
      while (listItem) {
        this.selectedFolder = '-' + listItem.name + this.selectedFolder;
        listItem = this.listItems.find((o: any) => o.key === listItem.parentRef);
      }

      if (!this.selectedFolder || this.selectedFolder === '') {
        this.selectedFolder = '-';
      }
    }
  }

  public async addFolder() {
    this.addPopupValue = false;
    const input = window.prompt('Geef de naam van de map op');
    if (input && input !== '') {
      try {
        await filesRepository.createFolder(this.type, this.id, input);
        notificationService.saved();
        this.fileUploaded();
      } catch (err) {
        notificationService.showAxiosError(err);
      }
    }
  }

  private async created() {
    this.accessToken = await this.$auth.getAccessToken() as string;
  }

  private fileUploaded() {
    this.showAddFilePopup = false;
    notificationService.saved();
    (this.$refs.treelist as any).instance.refresh();
  }

  get fileUploadSettings() {
    return {
      multiple: false,
      accept: '*',
      uploadUrl: `${settings.api}/api/Files/Upload`
       + `?type=${this.type}&id=${this.id}&folder=${this.selectedFolder}`,
      uploadHeaders: {
        Authorization: `Bearer ${this.accessToken}`,
      },
      uploadMode: 'useButtons',
      objectId: null,
      fileTypesSource: [
        { name: 'All types', value: '*' },
        { name: 'Images', value: 'image/*' },
        { name: 'Videos', value: 'video/*' },
      ],
      files: [],
    };
  }

  get dataSource() {
    const self = this;
    return {
      key: 'key',
      load: async (loadOptions: any) => {
        let folder = '';
        if (loadOptions.parentIds != null && loadOptions.parentIds.length > 0) {
          let listItem = self.listItems.find((o: any) =>  o.key === loadOptions.parentIds[0]);
          while (listItem) {
            folder = folder.length === 0 ? listItem.name : listItem.name + '/' + folder;
            listItem = self.listItems.find((o: any) =>  o.key === listItem.parentRef);
          }
        }

        const res = await filesRepository.lookup(this.type, this.id, folder);
        self.listItems = self.listItems.concat(res.data);
        return res;
      },
    };
  }
}
